import { createContext } from "react";

const AgenticReportingContext = createContext();

export default AgenticReportingContext;
